// src/pages/Enseignants/Attendance/components/AttendanceMobileHero.jsx

import React from "react";
import {
  FaClipboardCheck,
  FaMobileAlt,
  FaSyncAlt,
  FaUserCheck,
} from "react-icons/fa";

export default function AttendanceMobileHero({ loading, onRefresh }) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="relative overflow-hidden bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-7 text-white sm:px-8">
        <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/10 blur-2xl" />
        <div className="absolute -bottom-20 -left-20 h-56 w-56 rounded-full bg-white/10 blur-2xl" />

        <div className="relative mx-auto max-w-4xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
            <FaMobileAlt />
            Appel terrain
          </div>

          <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
            Présence des adhérents
          </h1>

          <p className="mx-auto mt-2 max-w-3xl text-sm leading-6 text-white/90">
            Sélectionnez le groupe, puis touchez les cartes pour marquer les
            présents et absents. L’enregistrement est immédiat.
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex min-h-[44px] items-center gap-2 rounded-xl bg-white/15 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/20 transition hover:bg-white/25 disabled:opacity-60"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>

            <div className="inline-flex min-h-[44px] items-center gap-2 rounded-xl bg-white/15 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/20">
              <FaClipboardCheck />
              Enregistrement immédiat
            </div>

            <div className="inline-flex min-h-[44px] items-center gap-2 rounded-xl bg-white/15 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/20">
              <FaUserCheck />
              Présent / absent
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}